module.exports = __webpack_public_path__ + "assets/img/bragon.3f90c884.png";